import { Sparkles } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useLegal } from '../lib/legalStrings';

/**
 * EU AI Act Article 50 — persistent, visible disclosure that content is AI-generated.
 * `variant="badge"` — small pill for use next to result areas.
 * `variant="banner"` — inline row used above result cards for extra emphasis.
 */
export default function AiDisclosure({ variant = 'badge', className = '' }) {
  const { language } = useLanguage();
  const L = useLegal(language);

  if (variant === 'banner') {
    return (
      <div
        role="note"
        aria-label={L.aiDisclosure.short}
        data-testid="ai-disclosure-banner"
        className={`flex items-center gap-2 px-3 py-2 rounded-lg bg-primary/10 border border-primary/20 text-xs text-primary font-medium ${className}`}
      >
        <Sparkles className="w-3.5 h-3.5 flex-shrink-0" aria-hidden="true" />
        <span>{L.aiDisclosure.long}</span>
      </div>
    );
  }

  return (
    <span
      role="note"
      aria-label={L.aiDisclosure.short}
      data-testid="ai-disclosure-badge"
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary/10 border border-primary/20 text-[11px] font-medium text-primary ${className}`}
    >
      <Sparkles className="w-3 h-3" aria-hidden="true" />
      {L.aiDisclosure.short}
    </span>
  );
}
